module.exports = __webpack_public_path__ + "static/media/prof.5e86cc9b.svg";